// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (
  currentRouteName,
  currentRouteComponent,
  serverPages,
) => ({
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({ default: pageModule.Home })),
            );
    },
    path: '/:context?/myaccount/paintPurchaseHistory',
    channel: null,
  },
});
